// @flow

import { authenticatedFetch } from '../../../api/request';

export function getOrgTeams(orgId: number) {
    return authenticatedFetch(`/v5/orgs/${orgId}/teams/all`);
}

export default {
    getOrgTeams
};



// WEBPACK FOOTER //
// ./src/view/my-store/api/getOrgTeams.js